import member from '@/page/member/index.vue'
import memberHistory from '@/page/member/components/history/index.vue'
import cancelTake from '@/page/member/components/cancelTake/index.vue'
import subscribeLoading from '@/page/member/components/subscribeLoading/index.vue'
import joinSubscription from '@/page/member/components/joinSubscription/index.vue'
import oldMember from '@/page/member/components/oldMember/index.vue'
import selectedReason from '@/page/member/components/selectedReason/index.vue'
import retainMember from '@/page/member/components/retainMember/index.vue'
import joinRules from '@/page/member/components/joinRules/index.vue'
import pauseSubscribe from '@/page/member/components/pauseSubscribe/index.vue'
import manageMainV2 from '@/page/member/pages/manage-main.vue'
import cancelSubscribeV2 from '@/page/member/pages/cancel-subscribe.vue'
import cancelRetainV2 from '@/page/member/pages/cancel-retain.vue'
import pauseSubscribeV2 from '@/page/member/pages/pause-subscribe.vue'
import pauseInfoV2 from '@/page/member/pages/pause-info.vue'
import firstMemberV2 from '@/page/member/pages/first-member.vue'
import rulesInfoV2 from '@/page/member/pages/rules-info.vue'
import memberHistoryV2 from '@/page/member/pages/member-history/index.vue'

const memberPage = {
  path: '/member',
  name: 'member',
  component: member,
}

const memberHistoryPage = {
  path: '/memberHistory',
  name: 'memberHistory',
  component: memberHistory,
}

const cancelTakePage = {
  path: '/cancelTake',
  name: 'cancelTake',
  component: cancelTake,
}

const subscribeLoadingPage = {
  path: '/subscribeLoading',
  name: 'subscribeLoading',
  component: subscribeLoading,
}

const joinSubscriptionPage = {
  path: '/joinSubscription',
  name: 'joinSubscription',
  component: joinSubscription,
}

const oldMemberPage = {
  path: '/oldMember',
  name: 'oldMember',
  component: oldMember,
}
// 退款原因选择页面 selectedReason
const selectedReasonPage = {
  path: '/selectedReason',
  name: 'selectedReason',
  component: selectedReason,
}
// 退款挽留页面 retainMember
const retainMemberPage = {
  path: '/retainMember',
  name: 'retainMember',
  component: retainMember,
}
// 规则页面 joinRules
const joinRulesPage = {
  path: '/joinRules',
  name: 'joinRules',
  component: joinRules,
}
// 暂停订阅页面 pauseSubscribe
const pauseSubscribePage = {
  path: '/pauseSubscribe',
  name: 'pauseSubscribe',
  component: pauseSubscribe,
}

// v2-管理页面
const manageMainPageV2 = {
  path: '/member/managerMain',
  name: 'memberManagerMain',
  component: manageMainV2,
}
// v2-退款原因选择页面
const cancelSubscribePageV2 = {
  path: '/member/cancelSubscribe',
  name: 'selectedReasonV2',
  component: cancelSubscribeV2,
}
// v2-退款挽留页面
const cancelRetainPageV2 = {
  path: '/member/cancelRetain',
  name: 'retainMemberV2',
  component: cancelRetainV2,
}
// v2-暂停订阅页面
const pauseSubscribePageV2 = {
  path: '/member/pauseSubscribe',
  name: 'pauseSubscribeV2',
  component: pauseSubscribeV2,
}
// v2-暂停订阅详情页
const pauseInfoPageV2 = {
  path: '/member/pauseInfo',
  name: 'pauseInfoV2',
  component: pauseInfoV2,
}
// v2-首次开启会员
const firstMemberPageV2 = {
  path: '/member/first',
  name: 'memeberFirst',
  component: firstMemberV2,
}
// v2-独立页条款
const rulesPageV2 = {
  path: '/member/ruleInfo',
  name: 'ruleInfoV2',
  component: rulesInfoV2,
}
// v2-购买记录
const memberHistoryPageV2 = {
  path: '/member/memberHistory',
  name: 'memberHistoryV2',
  component: memberHistoryV2,
}

export default [
  memberPage,
  memberHistoryPage,
  cancelTakePage,
  subscribeLoadingPage,
  joinSubscriptionPage,
  oldMemberPage,
  selectedReasonPage,
  retainMemberPage,
  joinRulesPage,
  pauseSubscribePage,
  manageMainPageV2,
  cancelSubscribePageV2,
  cancelRetainPageV2,
  pauseSubscribePageV2,
  pauseInfoPageV2,
  firstMemberPageV2,
  rulesPageV2,
  memberHistoryPageV2,
]
